"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionAction = exports.StaffRoles = void 0;
var StaffRoles;
(function (StaffRoles) {
    StaffRoles["MAIN_ADMIN"] = "MAIN_ADMIN";
    StaffRoles["OPERATIONS"] = "OPERATIONS";
    StaffRoles["SUPPORT"] = "SUPPORT";
    StaffRoles["SALES"] = "SALES";
})(StaffRoles = exports.StaffRoles || (exports.StaffRoles = {}));
var PermissionAction;
(function (PermissionAction) {
    PermissionAction["READ"] = "READ";
    PermissionAction["CREATE"] = "CREATE";
    PermissionAction["EDIT"] = "EDIT";
    PermissionAction["DELETE"] = "DELETE";
})(PermissionAction = exports.PermissionAction || (exports.PermissionAction = {}));
